<template>
  <div class="nothing gray">
    <img v-if="type === 'gift'" src="../assets/img/mygift.png">
    <img v-if="type === 'order'" src="../assets/img/myorder.png">
    <img v-if="type === 'coupons'" src="../assets/img/mycoupons.png">
    <p class="text-center">There's nothing here</p>
  </div>
</template>

<script>
export default {
  name: 'data-nothing',
  props: {
    type: String
  },
  methods: {

  },
  created () {

  },
  mounted () {

  }
}
</script>

<style lang="scss">
  .nothing {
    img {
      width: 100px;
      margin: 0 auto;
      margin-bottom: 20px;
    }
  }
</style>
